import {QueryClient} from '@tanstack/react-query';
import {isApiTokenError} from 'utils/app';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: (failureCount, error) => {
				// Don't retry on 401 errors to prevent redirect loops
				if (isApiTokenError(error)) {
					return false;
				}
				// Default retry behavior for other errors
				return failureCount < 3;
			},
		},
	},
});

export const invalidate = (queryClient, queries) => {
	queries.forEach(queryKey => {
		queryClient.invalidateQueries({queryKey});
	});
};

export const cancel = (queryClient, queries) => {
	queries.forEach(queryKey => {
		queryClient.cancelQueries({queryKey});
	});
};
